/**
 * GDPR Article 17 (right to erasure) request DTOs (P10-T11).
 *
 * B2B + HMRC 7-year retention forbids unconditional erasure — the
 * deletion request is a queue item that staff approve or reject. On
 * approval, a worker job (T12) nulls PII columns while preserving
 * financial rows.
 */
import { z } from "zod";
export const accountDeletionStatusValues = [
    "pending",
    "approved",
    "rejected",
    "redacted",
];
export const CreateDeletionRequestBody = z.object({
    reason: z.string().max(2000).optional(),
});
export const RejectDeletionRequestBody = z.object({
    decision_note: z.string().min(1).max(2000),
});
export const ApproveDeletionRequestBody = z.object({
    decision_note: z.string().max(2000).optional(),
});
